<template>
    <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
        <b-row>
            <b-col cols="" class="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <h2 class="text-left mb-0">{{ $t('maintenanceSummary.title') }}</h2>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="data-table team-data-table pt-3 pt-sm-4 bg-white rounded table-custom-border">
                            <div class="table_row team_table_row">
                                <div class="equipment-border filter-box" v-if="isTableMounted">
                                    <div class="d-flex mb-0 px-3 px-sm-4 flex-wrap gap-2">
                                        <b-form-group :label="$t('reportsCommon.selectDate')" class="text-left  report-datepicker">
                                            <date-picker v-model="filterFields.date" :formatter="momentFormat"
                                                @change="getTableData()" :range-separator="' - '"
                                                @clear="filterFields.date = ''" range
                                                class="date-picker-custom f-12" :shortcuts="shortcuts"></date-picker>
                                        </b-form-group>
                                        <b-form-group :label="$t('reportsCommon.selectUnits')" class="text-left report-fields ">
                                            <v-select multiple :options="allUnits" class="f-12"
                                                :reduce="(option) => option.id" v-model="filterFields.units"
                                                @input="getTableData()" @search="searchUnits" />
                                        </b-form-group>
                                        <b-form-group :label="$t('reportsCommon.selectTags')" class="text-left report-fields ">
                                            <v-select multiple :options="allTags" class="f-12"
                                                :reduce="(option) => option.id" v-model="filterFields.tags"
                                                @input="getTableData()" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div v-if="!isTableMounted"
                                    class="d-flex flex-wrap align-items-start maintenance-summary-grid px-3 px-sm-4 mt-0 mt-sm-2">
                                    <div class="summary-table-col" style="height: calc(100vh - 165px); overflow: hidden;">
                                        <b-skeleton-table :rows="15" :columns="4"
                                            :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                    </div>
                                    <div class="summary-table-col" style="height: calc(100vh - 165px); overflow: hidden;">
                                        <b-skeleton-table :rows="15" :columns="4"
                                            :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                    </div>
                                </div>
                                <div v-else
                                    class="d-flex flex-wrap align-items-start maintenance-summary-grid px-3 px-sm-4 mt-0 mt-sm-2">
                                    <div class="summary-table-col">
                                        <b-table responsive :fields="translatedCategoryFields" :items="categoriesData" hover
                                            :current-page="currentPage" :no-local-sorting="true" :busy.sync="isBusy"
                                            :sticky-header="'calc(100vh - 360px)'" :show-empty="emptyTable">
                                            <template #cell(total)="data">
                                                {{ getAmount(data.value) }}
                                            </template>
                                            <template #cell(share)="data">
                                                <div class="d-flex align-items-center share-cell">
                                                    <b-progress :value="shareValue(data.value)" :max="100" variant="primary"
                                                        class="flex-grow-1 mr-2 share-progress" height="8px" />
                                                    <span class="f-12 text-muted share-pct">{{
                                                        shareValue(data.value).toFixed(1) }}%</span>
                                                </div>
                                            </template>
                                            <template v-slot:custom-foot
                                                v-if="translatedCategoryFields.filter((item) => item.key === 'items').length">
                                                <tr class="sticky-footer">
                                                    <td v-for="(field, index) in translatedCategoryFields" :key="index">
                                                        <span v-if="field.key === 'items'" class="font-weight-bold">{{
                                                            totalCategoryItemsCount
                                                            ?
                                                            `${totalCategoryItemsCount}` : "-" }}</span>
                                                        <span v-if="field.key === 'total'" class="font-weight-bold">{{
                                                            totalCategoryAmount
                                                            ?
                                                            `$${getAmount(totalCategoryAmount)}` : "-" }}</span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </b-table>
                                    </div>
                                    <div class="summary-table-col">
                                        <b-table responsive :fields="translatedItemFields" :items="itemsData" hover
                                            :current-page="currentPage" :no-local-sorting="true" :busy.sync="isBusy"
                                            :sticky-header="'calc(100vh - 360px)'" :show-empty="emptyTable">
                                            <template #cell(total)="data">
                                                {{ getAmount(data.value) }}
                                            </template>
                                            <template #cell(share)="data">
                                                <div class="d-flex align-items-center share-cell">
                                                    <b-progress :value="shareValue(data.value)" :max="100" variant="primary"
                                                        class="flex-grow-1 mr-2 share-progress" height="8px" />
                                                    <span class="f-12 text-muted share-pct">{{
                                                        shareValue(data.value).toFixed(1) }}%</span>
                                                </div>
                                            </template>
                                            <template v-slot:custom-foot
                                                v-if="translatedCategoryFields.filter((item) => item.key === 'items').length">
                                                <tr class="sticky-footer">
                                                    <td v-for="(field, index) in translatedCategoryFields" :key="index">
                                                        <span v-if="field.key === 'items'" class="font-weight-bold">{{
                                                            totalItemsCount
                                                            ?
                                                            `${totalItemsCount}` : "-" }}</span>
                                                        <span v-if="field.key === 'total'" class="font-weight-bold">{{
                                                            totalItemsAmount
                                                            ?
                                                            `$${getAmount(totalItemsAmount)}` : "-" }}</span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </b-table>
                                    </div>
                                </div>
                                <div class="filtered-grand-total mt-3" v-if="isTableMounted">
                                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                                        <div class="text-left">
                                            <p class="fgt-label mb-1">{{ $t('maintenanceSummary.filteredGrandTotal') }}</p>
                                            <h2 class="fgt-value mb-0">${{ getAmount(grandTotal) }}</h2>
                                        </div>
                                        <div class="d-flex align-items-center fgt-stats">
                                            <div class="fgt-stat text-center">
                                                <p class="fgt-stat-label mb-1">{{ $t('maintenanceSummary.lineItems') }}</p>
                                                <p class="fgt-stat-value mb-0">{{ lineItemsCount }}</p>
                                            </div>
                                            <div class="fgt-stat text-center">
                                                <p class="fgt-stat-label mb-1">{{ $t('maintenanceSummary.units') }}</p>
                                                <p class="fgt-stat-value mb-0">{{ unitsCount }}</p>
                                            </div>
                                            <div class="fgt-stat text-center">
                                                <p class="fgt-stat-label mb-1">{{ $t('maintenanceSummary.records') }}</p>
                                                <p class="fgt-stat-value mb-0">{{ recordsCount }}</p>
                                            </div>
                                            <div class="fgt-stat text-center">
                                                <p class="fgt-stat-label mb-1">{{ $t('maintenanceSummary.avgPerRecord') }}</p>
                                                <p class="fgt-stat-value mb-0">${{ getAmount(avgPerRecord) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import DatePicker from 'vue2-datepicker';
import * as moment from "moment-timezone";
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "MaintenanceSummary",
    components: {
        DatePicker,
        vSelect,
    },
    data() {
        return {
            totalCategoryItemsCount: 0,
            totalCategoryAmount: 0,
            totalItemsCount: 0,
            totalItemsAmount: 0,
            filtersData: null,
            momentFormat: {
                //[optional] Date to String
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                //[optional]  String to Date
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            items: [],
            categoriesData: [],
            itemsData: [],
            grandTotal: 0,
            lineItemsCount: 0,
            unitsCount: 0,
            recordsCount: 0,
            avgPerRecord: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            isBusy: false,
            isTableMounted: false,
            emptyTable: false,
            rows: 0,
            filterFields: {
                search: '',
                date: '',
                units: [],
                tags: [],
            },
            allTags: [],
            allUnits: []
        }
    },
    computed: {
        ...mapGetters(["tags"]),
        translatedCategoryFields() {
            return [
                { key: 'category', label: this.$t('maintenanceSummary.categoryColumn'), stickyColumn: true, thClass: 'font-table-weight-bold' },
                { key: 'items', label: this.$t('maintenanceSummary.itemsColumn'), thClass: 'font-table-weight-bold' },
                { key: 'total', label: this.$t('maintenanceSummary.totalColumn'), thClass: 'font-table-weight-bold' },
                { key: 'share', label: this.$t('maintenanceSummary.shareColumn'), thClass: 'font-table-weight-bold' },
            ];
        },
        translatedItemFields() {
            return [
                { key: 'type', label: this.$t('maintenanceSummary.typeColumn'), stickyColumn: true, thClass: 'font-table-weight-bold' },
                { key: 'items', label: this.$t('maintenanceSummary.itemsColumn'), thClass: 'font-table-weight-bold' },
                { key: 'total', label: this.$t('maintenanceSummary.totalColumn'), thClass: 'font-table-weight-bold' },
                { key: 'share', label: this.$t('maintenanceSummary.shareColumn'), thClass: 'font-table-weight-bold' },
            ];
        },
        shortcuts() {
            const make = (text, fn) => ({ text, onClick: fn });
            return [
                make(this.$t('datepickerShortcuts.thisWeek'), () => {
                    const today = new Date();
                    const dayOfWeek = today.getDay() || 7;
                    const startOfWeek = new Date(today);
                    startOfWeek.setDate(today.getDate() - dayOfWeek + 1);
                    this.filterFields.date = [startOfWeek, today];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.thisMonth'), () => {
                    const today = new Date();
                    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                    this.filterFields.date = [startOfMonth, today];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.thisYear'), () => {
                    const today = new Date();
                    const startOfYear = new Date(today.getFullYear(), 0, 1);
                    this.filterFields.date = [startOfYear, today];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.lastWeek'), () => {
                    const today = new Date();
                    const dayOfWeek = today.getDay() || 7;
                    const startOfLastWeek = new Date(today);
                    startOfLastWeek.setDate(today.getDate() - dayOfWeek - 6);
                    const endOfLastWeek = new Date(today);
                    endOfLastWeek.setDate(today.getDate() - dayOfWeek);
                    this.filterFields.date = [startOfLastWeek, endOfLastWeek];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.lastMonth'), () => {
                    const today = new Date();
                    const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                    this.filterFields.date = [startOfLastMonth, endOfLastMonth];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.lastYear'), () => {
                    const today = new Date();
                    const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
                    const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
                    this.filterFields.date = [startOfLastYear, endOfLastYear];
                    this.getTableData();
                }),
            ];
        },
    },
    watch: {
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
        company: {
            async handler() {
                await this.getAllTags(this.userCompany);
                this.tags.map((item) => {
                    this.allTags.push({
                        id: item.add_tag,
                        label: item.add_tag,
                    });
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(["getAllMaintenaceLineItemsSummary", "getAllTags", "getFilteredEquipments"]),
        getAmount(val) {
            return parseFloat(val).toLocaleString("en", {
                useGrouping: false,
                minimumFractionDigits: 2,
            });
        },
        shareValue(val) {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async getTableData() {
            try {
                this.itemsData = []
                this.categoriesData = []
                this.isBusy = true
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if ((key === "tags" || key === "units") && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                    else if (key === 'date' && this.filterFields['date'][0]) {
                        url += `start_date=${moment(this.filterFields['date'][0]).format("YYYY-MM-DD")}&end_date=${moment(this.filterFields['date'][1]).format("YYYY-MM-DD")}&`
                    }
                    else if (this.filterFields[key] !== '' && key !== 'tags' && key !== 'date' && key !== 'units') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getAllMaintenaceLineItemsSummary(url);
                data.by_category.map((item) => {
                    this.categoriesData.push({
                        category: item.label,
                        items: item.count,
                        total: item.total,
                        share: item.share_pct,
                    })
                })
                data.by_item_type.map((item) => {
                    this.itemsData.push({
                        type: item.label,
                        items: item.count,
                        total: item.total,
                        share: item.share_pct,
                    })
                })
                this.totalCategoryItemsCount = data.by_category.reduce((acc, curr) => acc + curr.count, 0)
                this.totalCategoryAmount = data.by_category.reduce((acc, curr) => acc + curr.total, 0)
                this.totalItemsCount = data.by_item_type.reduce((acc, curr) => acc + curr.count, 0)
                this.totalItemsAmount = data.by_item_type.reduce((acc, curr) => acc + curr.total, 0)
                this.grandTotal = data.grand_total || 0
                this.lineItemsCount = data.line_items_count || 0
                this.unitsCount = data.units_count || 0
                this.recordsCount = data.records_count || 0
                this.avgPerRecord = data.avg_per_record || 0
                if (this.itemsData.length === 0 && this.categoriesData.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },
        async searchUnits(searchText) {
            if (searchText) {
                let options = [];
                const records = await this.getFilteredEquipments({ unit_no: searchText });
                records.forEach((x) => {
                    options.push({
                        id: `${x.unit_no}`,
                        label: `${x.unit_no}`,
                    });
                });

                // Merge and deduplicate by `id`
                this.allUnits = [
                    ...new Map(
                        [...this.allUnits, ...options].map(item => [item.id, item])
                    ).values()
                ];

            }
        },
    },
    mounted() {
        this.getTableData()
    }
}
</script>
<style>
.date-picker-custom.f-12 .mx-input-wrapper .mx-input {
    font-size: 12px !important;
}

.maintenance-summary-grid {
    gap: 24px;
}

.share-cell {
    min-width: 160px;
}

.share-progress {
    background-color: #f1f3f5;
}

.share-pct {
    min-width: 44px;
    text-align: right;
}

.maintenance-summary-grid .summary-table-col {
    flex: 1 1 0;
    min-width: 320px;
    border: 1px solid #E2E6F0;
    overflow: hidden;
    background: #ffffff;
}

.maintenance-summary-grid .summary-table-col .table {
    margin-bottom: 0;
}

.maintenance-summary-grid .summary-table-col .table> :not(:last-child)> :last-child>* {
    border-top: none;
}

.filtered-grand-total {
    background: #FAFAFA;
    color: #000;
    padding: 20px 24px;
}

.filtered-grand-total .fgt-label {
    font-size: 12px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #000;
    font-weight: 500;
}

.filtered-grand-total .fgt-value {
    font-size: 30px;
    font-weight: 700;
    color: #000;
}

.filtered-grand-total .fgt-stats {
    gap: 32px;
}

.filtered-grand-total .fgt-stat-label {
    font-size: 11px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #000;
    font-weight: 500;
}

.filtered-grand-total .fgt-stat-value {
    font-size: 18px;
    font-weight: 600;
    color: #000;
}

@media (max-width: 767px) {
    .maintenance-summary-grid {
        gap: 16px;
    }

    .maintenance-summary-grid .summary-table-col {
        flex: 1 1 100%;
        min-width: 0;
    }

    .filtered-grand-total {
        padding: 16px 18px;
    }

    .filtered-grand-total .fgt-value {
        font-size: 24px;
    }

    .filtered-grand-total .fgt-stats {
        gap: 18px;
        width: 100%;
        justify-content: space-between;
        margin-top: 16px;
    }
}
</style>